export default {
  code: 'Mã loại cán bộ',
  name: 'Tên loại cán bộ',
  description: 'Mã nghiệp vụ',
  is_system: 'Hệ thống',
  inactive: 'Ngừng theo dõi',
  Constant: {
    Payroll: 'Biên chế',
  },
  QuickSearch: {
    Title: 'Tìm loại cán bộ',
  },
  List: {
    Title: 'Loại Cán bộ',
    ActionColumn: 'Chức năng',
  },
};
